<template>
  <div class="docs">
    <div class="col-md-12 jumbotron my-3 p-3">
      <div class="text-center my-2">
        <span class="badge badge-info">Status of the comment is only correct beyond 20th of Jan 2021.</span>
      </div>
      <table class="table">
        <thead class="thead-light">
          <tr>
            <!-- <th scope="col">B ID</th> -->
            <th scope="col">Current Flag</th>
            <th scope="col">Comment</th>
            <th>Agent</th>
            <th scope="col">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in support" :key="index">
            <!-- <th scope="row">{{ data.bookingId }}</th> -->
            <td>
              <span class="badge badge-success">{{
                checkFunnel(data.current_flag)
              }}</span>
            </td>
            <td>{{ data.comment }}</td>
            <td>
              <span class="badge badge-primary">{{ data.userName}}</span>
            </td>
            
            <td style="white-space: nowrap;">
              {{ data.createdAt | moment("LLL") }}
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="mt-5 col-md-12 text-center"
        v-if="support.length == 0 && !makingAJAX"
      >
        <p>We didn't get any data.</p>
      </div>
    </div>


  </div>
</template>

<script>
const axios = require("axios");
import * as _ from 'lodash'
import json from "../../../Inventory/flags";

export default {
  data() {
    return {
      flagsJson: json,
      cx_id: 0,
      phone_number: "",
      support: "",
    };
  },
  created() {
    this.$store.state.customer_by_number = [];
    this.phone_number = this.$route.params.phone;
    this.cx_id = this.$route.params.cx_id;
    this.loadData();
  },
  methods: {
    checkFunnel(id) {
      var x = this.flagsJson.filter((x) => {
        return x.flag == id;
      });
      return x[0].funnel + "-" + x[0].state;
    },
    loadData() {
      axios
        .post(
          "https://api.on-track.in/api/getAgentCommentData",
          {
            bookingId: this.cx_id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((res) => {
          this.support = _.orderBy(res.data, "endDate", 'desc');
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
  },
  computed: {
    makingAJAX(){
      return this.$store.state.makingAJAX
    },
  },
};
</script>

<style scoped>
.header {
  font-size: 15px;
  color: blue;
}
.labels {
  color: gray;
  font-size: 12px;
}
</style>
